/* eslint-disable no-underscore-dangle */
import React from 'react'
import * as PropTypes from 'prop-types'
// import { getVenue, showVenue, E_SDK_EVENT } from '@mappedin/mappedin-js'
// import '@mappedin/mappedin-js/lib/index.css'

import { setGACustomEvent } from '../../../services/analytics/google-analytics'
import Icon from '../../ui/Icon/Icon'
import {
  MapView,
  MapViewWrapper,
  TransparentLayer,
  FloorControlArrow,
  FloorControlLabel,
  FloorControlSelect,
  FloorControlOption,
  FloorShortName,
  FloorControlsWrapper,
  FloorControls,
  ViewControlWrapper,
  Compass,
  CompassContainer,
  CompassLabel,
  CompassWrapper,
  ZoomControlItem,
  ZoomControlWrapper,
  SearchButton,
  SearchButtonLabel,
  SearchButtonList,
  SearchControlContainer,
  SearchControlWrapper,
  SearchField,
  SearchHeader,
  SearchMain,
  SearchResult,
  SearchTitle,
  DirectionWrapper,
  DropdownWrapper,
  DropdownItems,
  ReverseButton,
  ReverseWrapper,
  LocationLogo,
  LocationName,
  LocationsItemMain,
  LocationsWrapper,
  FoundNone,
  AccessibleButton,
  AccessibleIcon,
  AccessibleIconDivider,
  IconButton,
  StyledActionButton,
  WithAddress,
  DropdownOptionLabel,
  DropdownOptionAddress,
  ErrorMessage,
  SurveyButtonContainer,
  SurveyButton,
  SurveyButtonText,
  SurveyButtonContainerMobile,
} from './IndoorMap.style'

import sortFunction from '../../../services/data/sortFunction'
import CustomDropdown from '../../ui/CustomDropdown/CustomDropdown'
import { withMappedinKeys } from '../../../services/hooks/useMappedinKeys'
import { MAP_SURVEY } from '../../../services/data/profilePages.json'

const MAP_COLORS = {
  selected: '#4ca1fc',
  path: '#4ca1fc',
}
const MAPPEDIN_SDK =
  'https://d1p5cqqchvbqmy.cloudfront.net/websdk/v4.0.16/mappedin.js'
const MAPPEDIN_STYLES =
  'https://d1p5cqqchvbqmy.cloudfront.net/websdk/v4.0.16/mappedin.css'

const SearchControlHeader = ({ children, onClose, handleBack }) => {
  return (
    <SearchHeader>
      <IconButton onClick={handleBack}>
        <Icon name="arrow-left" />
      </IconButton>
      <SearchTitle>{children}</SearchTitle>
      <IconButton fontSize="20px" onClick={onClose}>
        <Icon name="x" />
      </IconButton>
    </SearchHeader>
  )
}

const LocationsItem = ({ children, logo, onClick }) => {
  const itemLogo = logo ? logo.original : ''

  return (
    <LocationsItemMain onClick={onClick}>
      <LocationLogo image={itemLogo} />
      <LocationName>{children}</LocationName>
    </LocationsItemMain>
  )
}

class IndoorMap extends React.Component {
  constructor(props) {
    super(props)

    this.scriptId = 'mappedin-script'
    this.stylesId = 'mappedin-styles'

    this.mappedinELement = React.createRef()

    const {
      searchMode,
      targetLocation,
      nextTargetLocation,
      selectedCategory,
      isAccessible,
    } = props

    this.state = {
      mappedinFunctionLoaded: false,
      isFloorControlOpen: false,
      isAccessible,
      searchMode,
      targetLocation,
      nextTargetLocation,
      selectedCategory,
      floors: [],
      rotation: 0,
      categoryList: [],
      currentFloor: {},
      mallPolygons: [],
      mallLocations: [],
      amenityLocations: [],
      currentPath: [],
      searchResult: [],
      directionError: '',
    }

    this.resetValues = {
      isFloorControlOpen: false,
      searchMode: '',
      targetLocation: null,
      nextTargetLocation: null,
      selectedCategory: null,
    }

    this.Mappedin = {}
    this.MappedinFunctions = {
      mapView: null,
      venue: null,
      search: null,
      analytics: null,
    }
    this.locationsByPolygon = {}

    this.searchField = React.createRef()
  }

  componentDidMount() {
    const getMappedin = window => {
      this.Mappedin = window.Mappedin
      this.init()
    }

    if (!document.getElementById(this.scriptId)) {
      const script = document.createElement('script')
      script.id = this.scriptId
      script.src = MAPPEDIN_SDK
      script.async = false
      this.loadCSS()
      script.onload = () => {
        getMappedin(window)
      }
      document.body.appendChild(script)
    } else if (typeof window !== 'undefined') {
      getMappedin(window)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { mapView } = this.MappedinFunctions
    const { searchMode, nextTargetLocation } = this.props
    const {
      searchMode: searchModeState,
      nextTargetLocation: nextTargetLocationState,
    } = this.state
    if (
      prevProps.nextTargetLocation &&
      !nextTargetLocation &&
      nextTargetLocationState !== nextTargetLocation
    ) {
      this.updateStateValue({
        nextTargetLocation,
      })
    }

    this.syncStateToProps(prevProps, 'targetLocation')
    this.syncStateToProps(prevProps, 'selectedCategory')
    this.syncStateToProps(prevProps, 'isAccessible')
    this.syncStateToProps(prevProps, 'searchMode')

    if (
      prevProps.searchMode !== searchMode ||
      searchModeState !== prevState.searchMode
    ) {
      mapView.cachedPadding = {
        bottom: 50,
        left: 10,
        right: 10,
        top: 50,
      }
    }
  }

  componentWillUnmount() {
    this.destroyMap()
  }

  destroyMap = () => {
    const { mapView } = this.MappedinFunctions

    try {
      mapView.destroy()
    } catch (e) {}
    document.getElementById(this.scriptId).remove()
  }

  getPolygonLocations = floors => (list, item) => {
    const { name, category, logo, type, id: locationId } = item
    return [
      ...list,
      ...item.polygons.map(polygon => {
        const floorData = floors.find(floor => floor.id === polygon.map) || {}

        return {
          ...polygon,
          name,
          category,
          logo,
          type,
          locationId,
          value: `${locationId}|${polygon.id}`,
          floorName: floorData.name,
        }
      }),
    ]
  }

  loadCSS = () => {
    const styles = document.createElement('link')
    styles.id = this.stylesId
    styles.setAttribute('rel', 'stylesheet')
    styles.setAttribute('type', 'text/css')
    styles.setAttribute('href', MAPPEDIN_STYLES)
    document.body.appendChild(styles)
  }

  onDataLoaded = mapView => {
    const locationsWithPolygon = []
    const { locations, maps, categories } = mapView.venue

    for (let j = 0, jLen = locations.length; j < jLen; ++j) {
      const location = locations[j]

      if (location.polygons.length > 0) {
        locationsWithPolygon.push(location)
      }

      const locationPolygons = location.polygons
      for (let k = 0, kLen = locationPolygons.length; k < kLen; ++k) {
        const polygon = locationPolygons[k]
        mapView.addInteractivePolygon(polygon)

        const oldLocation = this.locationsByPolygon[polygon.id]
        if (oldLocation == null || oldLocation.sortOrder > location.sortOrder) {
          this.locationsByPolygon[polygon.id] = location
        }
      }
    }
    const floors = maps.sort((a, b) => b.elevation - a.elevation)

    const locationList = locationsWithPolygon
      .map(({ id, name, type, logo, description, polygons }) => {
        const map = polygons[0] ? polygons[0].map : ''

        const originFloor =
          polygons.length === 1
            ? floors.find(floor => floor.id === map) || {}
            : {}

        return {
          name,
          value: id,
          type,
          logo,
          description,
          floorName: originFloor.name,
        }
      })
      .sort(sortFunction('name'))

    const polygonList = locationsWithPolygon.reduce(
      this.getPolygonLocations(floors),
      [],
    )

    const amenityList = locationList.filter(
      location => location.type === 'amenities',
    )

    this.setState({
      floors,
      amenityLocations: amenityList,
      mallPolygons: polygonList,
      mallLocations: locationList,
      categoryList: categories
        .filter(props => props.locations.length)
        .map(({ name, id, locations: categoryLocations }) => ({
          name,
          id,
          locations: categoryLocations
            .map(location => {
              const map = location.polygons[0] ? location.polygons[0].map : ''

              const originFloor =
                location.polygons.length === 1
                  ? floors.find(floor => floor.id === map) || {}
                  : {}

              return {
                ...location,
                value: location.id,
                floorName: originFloor.name,
              }
            })
            .sort(sortFunction('name')),
        }))
        .sort(sortFunction('name')),
    })
    this.setCurrentFloor()
  }

  clearMap = () => {
    const { mapView } = this.MappedinFunctions

    mapView.removeAllPaths()
    // mapView.removePathSegment()
    mapView.removeAllMarkers()
    mapView.clearAllPolygonColors()

    this.setState({
      searchResult: [],
    })

    try {
      this.searchField.current.value = ''
    } catch (e) {}
  }

  setSearchMode = async searchMode => {
    const { handleSearchModeChange, changeDescription } = this.props
    const { targetLocation, mallPolygons } = this.state
    const { resetValues } = this

    let newTargetLocation = ''

    const newState = {
      ...resetValues,
      searchMode,
    }

    if (searchMode === 'directions') {
      newTargetLocation = targetLocation
      newState.targetLocation = targetLocation
      const retrievedLocation = mallPolygons.find(
        props => props.value === targetLocation,
      )
      const { name, description } = retrievedLocation || {}
      changeDescription({
        title: name,
        description,
      })
    } else {
      changeDescription()
    }

    await handleSearchModeChange(searchMode, newTargetLocation)

    this.clearMap()
    this.setState({
      ...newState,
      directionError: '',
    })
  }

  setMappedinFunctions = data => {
    this.MappedinFunctions = data

    this.setState({
      mappedinFunctionLoaded: true,
    })
  }

  onPolygonClicked = polygon => {
    const { mapView } = this.MappedinFunctions
    mapView.Camera.focusOn({
      targets: {
        polygons: [polygon],
      },
    })
    const location = this.locationsByPolygon[polygon.id]
    const locationId = location ? location.id : ''

    this.showLocation(`${locationId}|${polygon.id}`)
  }

  setFloor = async (floorId, zoomOut = true) => {
    const { mapView } = this.MappedinFunctions
    const { setCurrentFloor, focusPath } = this

    await mapView.setMap(floorId)

    focusPath()
    setCurrentFloor()
    if (zoomOut) {
      this.showEntireMap()
    }
  }

  setCurrentFloor = () => {
    const { mapView } = this.MappedinFunctions
    const { floors } = this.state

    let currentFloor = {}
    for (let m = 0, mLen = floors.length; m < mLen; ++m) {
      const map = floors[m]
      const { id, name } = map
      if (id === mapView.currentMap.id) {
        currentFloor = {
          id,
          name,
        }
      }
    }

    this.setState({
      currentFloor,
    })
  }

  resetRotation = () => {
    const { mapView } = this.MappedinFunctions
    mapView.Camera.animate({
      animationOptions: { duration: 400 },
      positionOptions: { tilt: 0 },
    })
  }

  showEntireMap = () => {
    const { mapView } = this.MappedinFunctions

    mapView.Camera.set({ zoom: mapView.Camera.maxZoom })
  }

  zoomIn = () => {
    const { mapView } = this.MappedinFunctions
    let zoom = mapView.Camera.zoom - 2000
    zoom = zoom < mapView.Camera.minZoom ? mapView.Camera.minZoom : zoom

    mapView.Camera.animate({
      animationOptions: { duration: 400 },
      positionOptions: { zoom },
    })
  }

  zoomOut = () => {
    const { mapView } = this.MappedinFunctions
    let zoom = mapView.Camera.zoom + 2000
    zoom = zoom > mapView.Camera.maxZoom ? mapView.Camera.maxZoom : zoom

    mapView.Camera.animate({
      animationOptions: { duration: 400 },
      positionOptions: { zoom },
    })
  }

  setPath = path => {
    this.setState({
      currentPath: path,
    })
  }

  focusPath = () => {
    const { mapView } = this.MappedinFunctions
    const { currentPath } = this.state

    mapView.Camera.focusOn({
      targets: {
        nodes: currentPath,
      },
    })
  }

  handleSearch = async e => {
    const { mallPolygons } = this.state
    const { value } = e.target
    const searchResult = mallPolygons.filter(data =>
      this.filterOption({ data }, value),
    )

    this.setState({
      searchResult,
    })
  }

  showLocation = async (targetedlocation, mallFloor) => {
    const { handleShowLocation, changeDescription } = this.props
    this.clearMap()

    if (targetedlocation) {
      const [locationId, polygonId] = targetedlocation.split('|')

      const { mapView } = this.MappedinFunctions
      const { locations } = mapView.venue
      const location = locations.find(props => props.id === locationId)

      if (location) {
        const floorLocation = location.polygons.find(
          polygon => polygon.map === mallFloor,
        )

        const locationPolygon =
          mallFloor && floorLocation ? floorLocation : location.polygons[0]

        const selectedPolygon = polygonId
          ? location.polygons.find(polygon => polygon.id === polygonId)
          : locationPolygon

        const targetLocation = polygonId
          ? targetedlocation
          : `${targetedlocation}|${selectedPolygon.id}`

        if (selectedPolygon) {
          await this.setFloor(selectedPolygon.map, false)
          mapView.setPolygonColor(selectedPolygon.id, MAP_COLORS.selected)
          mapView.Camera.focusOn({
            targets: {
              polygons: [selectedPolygon],
            },
          })
          // analytics.locationSelected(location)

          const { name, description } = location

          changeDescription({
            title: name,
            description,
          })

          this.setState({
            ...this.resetValues,
            targetLocation,
          })

          handleShowLocation(targetLocation, location.externalId)
        }
      }
    }
  }

  showDirections = async (value, type) => {
    const { mapView } = this.MappedinFunctions
    const {
      handleShowDirection,
      changeDescription,
      updateUrlByDirections,
    } = this.props
    const {
      targetLocation,
      nextTargetLocation,
      isAccessible,
      mallLocations,
      floors,
    } = this.state

    const directionFrom = type === 'from' ? value : nextTargetLocation
    const directionTo = type === 'to' ? value : targetLocation
    const accessible = type === 'accessibility' ? value : isAccessible

    this.setState(
      {
        targetLocation: directionTo,
        nextTargetLocation: directionFrom,
        isAccessible: accessible,
        directionError: '',
      },
      async () => {
        if (
          directionTo &&
          directionFrom &&
          directionTo !== 'null' &&
          directionFrom !== 'null'
        ) {
          this.clearMap()
          const retrievedLocation = mallLocations.find(
            props => props.value === directionTo.split('|')[0],
          )
          const { name, description } = retrievedLocation || {}
          changeDescription({
            title: name,
            description,
          })

          const { locations } = mapView.venue

          let locationFromNode = null
          let locationToNode = null

          if (directionFrom && directionTo && directionFrom !== directionTo) {
            const [dfLocationId, dfPolygonId] = directionFrom.split('|')
            const [dtLocationId, dtPolygonId] = directionTo.split('|')

            locations.every(loc => {
              if (dfLocationId === loc.id) {
                locationFromNode = loc
              }
              if (dtLocationId === loc.id) {
                locationToNode = loc
              }
              return !(locationFromNode && locationToNode)
            })

            const locationFromPolygon = dfPolygonId
              ? locationFromNode.polygons.find(
                  polygon => polygon.id === dfPolygonId,
                )
              : locationFromNode.polygons[0]
            const locationToPolygon = dtPolygonId
              ? locationToNode.polygons.find(
                  polygon => polygon.id === dtPolygonId,
                )
              : locationToNode.polygons[0]

            if (locationFromPolygon && locationToPolygon) {
              const online = false
              const forceNearest = true
              const fromNode = online ? locationFromNode : locationFromPolygon
              const toNode =
                online || forceNearest ? locationToNode : locationToPolygon

              try {
                const directions = fromNode.directionsTo(toNode, {
                  flattenPath: true,
                })

                if (directions) {
                  mapView.Journey.draw(directions, {
                    pathOptions: {
                      // nearRadius: 1,
                      // farRadius: 2,
                      color: MAP_COLORS.path,
                    },
                  })

                  const originFloor = floors.find(
                    floor => floor.id === locationFromPolygon.map,
                  )
                  const destinationFloor = floors.find(
                    floor => floor.id === locationToPolygon.map,
                  )

                  this.setState({
                    originFloor: originFloor.name,
                    destinationFloor: destinationFloor.name,
                  })

                  handleShowDirection(
                    directionTo,
                    locationToNode.externalId,
                    directionFrom,
                  )
                  this.setPath(directions.path)
                  this.setFloor(originFloor, true)
                  this.focusPath()
                }
              } catch (error) {
                mapView.removeAllPaths()
                mapView.clearAllPolygonColors()
                mapView.removeAllMarkers()
                this.showEntireMap()
                this.setState({
                  directionError: error.message.replace('Error: ', ''),
                })
              }
            }
          }
        } else if (directionTo || directionFrom) {
          updateUrlByDirections({
            locationId: (type === 'to' && value) || directionTo,
            nextLocationId: (type === 'from' && value) || directionFrom,
            accessible: isAccessible,
          })
        } else {
          // add error handling
        }
      },
    )
  }

  handleBack = () => {
    const { handleBack } = this.props

    if (handleBack) {
      handleBack()
      return
    }

    this.setSearchMode('')
  }

  handleShowCategory = categoryId => {
    const { handleSearchModeChange, changeDescription } = this.props

    this.setState({
      selectedCategory: categoryId,
    })

    changeDescription()
    handleSearchModeChange('categories', categoryId)
  }

  reverseDirection = () => {
    const { targetLocation, nextTargetLocation } = this.state

    this.setState(
      {
        targetLocation: nextTargetLocation,
        nextTargetLocation: targetLocation,
      },
      () => {
        this.showDirections()
      },
    )
  }

  updateStateValue = state => {
    this.setState(state)
  }

  syncStateToProps = (prevProps, propName) => {
    // eslint-disable-next-line react/destructuring-assignment
    const currentProp = this.props[propName]
    // eslint-disable-next-line react/destructuring-assignment
    const currentState = this.state[propName]

    if (prevProps[propName] !== currentProp && currentProp !== currentState) {
      const newState = {}
      newState[propName] = currentProp

      this.setState(newState)
    }
  }

  toggleFloorControl = (value = null) => {
    const { isFloorControlOpen } = this.state

    this.setState({
      isFloorControlOpen:
        typeof value === 'boolean' ? value : !isFloorControlOpen,
    })
  }

  toggleAccessible = (value = null) => {
    const { isAccessible: isAccessibleState } = this.state
    const isAccessible = typeof value === 'boolean' ? value : !isAccessibleState

    this.setState({
      isAccessible,
    })
    // this.handleChangeDirection(null, null, isAccessible)
  }

  getFloor = target => {
    const { mallPolygons, floors } = this.state

    const location = mallPolygons.find(
      mallLocation => mallLocation.value === target,
    )

    if (location) {
      const floor = floors.find(props => props.id === location.map)

      if (floor) {
        return floor.name
      }
    }

    return ''
  }

  getFloorId = target => {
    const { mallPolygons, floors } = this.state

    const location = mallPolygons.find(
      mallLocation => mallLocation.value === target,
    )

    if (location) {
      const floor = floors.find(props => props.id === location.map)

      if (floor) {
        return floor.id
      }
    }

    return ''
  }

  filterOption = ({ data }, value) => {
    const { name } = data

    if (value) {
      if (name) {
        return name.toLowerCase().includes(value.toLowerCase())
      }
    }

    return true
  }

  init = async () => {
    const { mall, getMappedinKeys } = this.props
    const { current: MappedinElement } = this.mappedinELement
    const keys = await getMappedinKeys()
    const venueData = await this.Mappedin.getVenue({
      ...keys,
      venue: mall,
    })

    if (MappedinElement) {
      const mapView = await this.Mappedin.showVenue(MappedinElement, venueData)
      mapView.labelAllLocations({
        flatLabels: true,
        excludeTypes: [],
      })
      mapView.addInteractivePolygonsForAllLocations()
      this.setMappedinFunctions({ mapView })
      this.onDataLoaded(mapView)
      mapView.on(
        this.Mappedin.E_SDK_EVENT.POLYGON_CLICKED,
        this.onPolygonClicked,
      )
    }
  }

  handleSurvey = () => {
    const { displayProfileModal, setProfileModalPage, accessToken } = this.props

    setGACustomEvent('survey_prompt_shown', {
      user_type: accessToken ? 'Basic' : 'Guest',
      platform: 'Web',
      source: 'map_feature',
    })

    displayProfileModal(true)
    setProfileModalPage(MAP_SURVEY)
  }

  render() {
    const {
      mall,
      merchantName,
      preview,
      handleShowLocation,
      webview,
      selectedMallAddress,
      onRedirect,
      isFeatureAvailable,
      isSurveyAvailable,
      displayProfileModal,
      setProfileModalPage,
      ...restProps
    } = this.props
    const {
      currentFloor,
      isFloorControlOpen,
      floors,
      rotation,
      searchMode,
      targetLocation,
      nextTargetLocation,
      selectedCategory,
      categoryList,
      amenityLocations,
      mallPolygons,
      mallLocations,
      isAccessible,
      searchResult,
      directionError,
    } = this.state

    // Used MerchantExploreLocation location value and targetLocation is empty
    /* const merchantLocation =
      merchantName &&
      mallPolygons.find(
        location =>
          location.name.toLowerCase() === merchantName.toLowerCase() &&
          (location.value || '').split('|')[1] ===
            (targetLocation ? targetLocation.split('|')[1] : ''),
      ) */

    const merchantExploreLocation =
      merchantName &&
      mallPolygons.find(
        location => location.name.toLowerCase() === merchantName.toLowerCase(),
      )

    const indoorMapUrl = merchantExploreLocation
      ? `/wayfinding/${mall}/directions/${merchantExploreLocation &&
          merchantExploreLocation.value}`
      : `/wayfinding/${mall}/directions`

    const originData =
      mallPolygons.find(polygon => polygon.value === nextTargetLocation) ||
      mallLocations.find(location => location.value === nextTargetLocation) ||
      null
    const destinationData =
      mallLocations.find(
        location =>
          location.value ===
          (targetLocation ? targetLocation.split('|')[0] : ''),
      ) || null

    return (
      <MapViewWrapper {...restProps}>
        <MapView ref={this.mappedinELement} />
        {preview && (
          <div>
            <TransparentLayer />
            <StyledActionButton
              small
              variant="primary"
              onClick={onRedirect}
              to={isFeatureAvailable ? indoorMapUrl : null}
              disabled={!indoorMapUrl}
            >
              Get Directions
            </StyledActionButton>
          </div>
        )}
        {!preview && !webview && currentFloor.id && (
          <>
            <SearchControlWrapper>
              <SearchControlContainer>
                {(!searchMode || searchMode === 'search') && (
                  <SearchMain>
                    <SearchField
                      ref={this.searchField}
                      onChange={this.handleSearch}
                    />
                    {searchResult.length > 0 && (
                      <SearchResult>
                        {searchResult.map(
                          ({ value, name, logo, floorName }) => (
                            <LocationsItem
                              key={value}
                              onClick={() =>
                                this.showLocation(value, currentFloor.id)
                              }
                              logo={logo}
                            >
                              <DropdownOptionLabel>{name}</DropdownOptionLabel>
                              <DropdownOptionAddress>
                                {floorName} {selectedMallAddress}
                              </DropdownOptionAddress>
                            </LocationsItem>
                          ),
                        )}
                      </SearchResult>
                    )}
                    <SearchButtonList>
                      <SearchButton
                        onClick={() => this.setSearchMode('amenities')}
                      >
                        <Icon name="smiley" />
                        <SearchButtonLabel>Amenities</SearchButtonLabel>
                      </SearchButton>
                      <SearchButton
                        onClick={() => this.setSearchMode('categories')}
                      >
                        <Icon name="cardview" />
                        <SearchButtonLabel>Categories</SearchButtonLabel>
                      </SearchButton>
                      <SearchButton
                        onClick={() => this.setSearchMode('directions')}
                      >
                        <Icon name="location" />
                        <SearchButtonLabel>Location</SearchButtonLabel>
                      </SearchButton>
                    </SearchButtonList>
                  </SearchMain>
                )}
                {searchMode === 'amenities' && (
                  <>
                    <SearchControlHeader
                      onClose={() => this.setSearchMode('')}
                      handleBack={this.handleBack}
                    >
                      Amenities
                    </SearchControlHeader>
                    <LocationsWrapper>
                      {!amenityLocations.length && (
                        <FoundNone>No Amenities Found</FoundNone>
                      )}
                      {amenityLocations.map(
                        ({ value, name, logo, floorName }) => (
                          <LocationsItem
                            key={value}
                            onClick={() =>
                              this.showLocation(value, currentFloor.id)
                            }
                            logo={logo}
                          >
                            <DropdownOptionLabel>{name}</DropdownOptionLabel>
                            <DropdownOptionAddress>
                              {floorName} {selectedMallAddress}
                            </DropdownOptionAddress>
                          </LocationsItem>
                        ),
                      )}
                    </LocationsWrapper>
                  </>
                )}
                {searchMode === 'categories' && (
                  <>
                    <SearchControlHeader
                      onClose={() => this.setSearchMode('')}
                      handleBack={this.handleBack}
                    >
                      Categories
                    </SearchControlHeader>
                    <LocationsWrapper>
                      {selectedCategory
                        ? categoryList
                            .filter(({ id }) => id === selectedCategory)
                            .map(({ locations }) =>
                              locations.map(
                                ({ value, name, logo, floorName }) => (
                                  <LocationsItem
                                    key={value}
                                    onClick={() =>
                                      this.showLocation(value, currentFloor.id)
                                    }
                                    logo={logo}
                                  >
                                    <DropdownOptionLabel>
                                      {name}
                                    </DropdownOptionLabel>
                                    <DropdownOptionAddress>
                                      {floorName} {selectedMallAddress}
                                    </DropdownOptionAddress>
                                  </LocationsItem>
                                ),
                              ),
                            )
                        : categoryList.map(({ name, id, locations, logo }) => (
                            <LocationsItem
                              key={id}
                              onClick={() => this.handleShowCategory(id)}
                              logo={logo}
                            >
                              {name}{' '}
                              <span>
                                {locations.length} location
                                {locations.length > 1 ? 's' : ''}
                              </span>
                            </LocationsItem>
                          ))}
                    </LocationsWrapper>
                  </>
                )}
                {searchMode === 'directions' && (
                  <>
                    <SearchControlHeader
                      onClose={() => this.setSearchMode('')}
                      handleBack={this.handleBack}
                    >
                      Directions
                    </SearchControlHeader>
                    <DirectionWrapper>
                      <DropdownWrapper>
                        <DropdownItems>
                          <WithAddress>
                            <CustomDropdown
                              placeholder="Select departure"
                              options={mallPolygons}
                              isClearable={false}
                              formatOptionLabel={item => {
                                return (
                                  <>
                                    <DropdownOptionLabel>
                                      {item.name}
                                    </DropdownOptionLabel>
                                    <DropdownOptionAddress>
                                      {item.floorName} {selectedMallAddress}
                                    </DropdownOptionAddress>
                                  </>
                                )
                              }}
                              filterOption={this.filterOption}
                              onChange={option => {
                                if (option) {
                                  this.showDirections(option.value, 'from')

                                  return true
                                }

                                return null
                              }}
                              value={originData}
                            />
                          </WithAddress>
                          <WithAddress>
                            <CustomDropdown
                              placeholder="Select destination"
                              options={mallLocations}
                              isClearable={false}
                              formatOptionLabel={item => {
                                return (
                                  <>
                                    <DropdownOptionLabel>
                                      {item.name}
                                    </DropdownOptionLabel>
                                    <DropdownOptionAddress>
                                      {item.floorName} {selectedMallAddress}
                                    </DropdownOptionAddress>
                                  </>
                                )
                              }}
                              filterOption={this.filterOption}
                              onChange={option => {
                                if (option) {
                                  this.showDirections(option.value, 'to')

                                  return true
                                }

                                return null
                              }}
                              value={destinationData}
                            />
                          </WithAddress>
                          <ErrorMessage>{directionError}</ErrorMessage>
                        </DropdownItems>
                        <ReverseWrapper>
                          <ReverseButton
                            type="button"
                            onClick={this.reverseDirection}
                          >
                            <Icon name="switch" />
                          </ReverseButton>
                        </ReverseWrapper>
                      </DropdownWrapper>

                      {isSurveyAvailable && (
                        <SurveyButtonContainerMobile>
                          <SurveyButton onClick={() => this.handleSurvey()}>
                            <SurveyButtonText>
                              Answer our quick survey
                            </SurveyButtonText>
                          </SurveyButton>
                        </SurveyButtonContainerMobile>
                      )}

                      <AccessibleButton
                        onClick={() =>
                          this.showDirections(!isAccessible, 'accessibility')
                        }
                        accessible={isAccessible}
                      >
                        <AccessibleIcon>
                          <Icon name="accessible" />
                        </AccessibleIcon>
                        <AccessibleIconDivider />
                        <AccessibleIcon>
                          <Icon name="elevator" />
                        </AccessibleIcon>
                      </AccessibleButton>
                    </DirectionWrapper>
                  </>
                )}
              </SearchControlContainer>
            </SearchControlWrapper>
            <FloorControlsWrapper>
              <FloorControls>
                <FloorControlArrow onClick={this.toggleFloorControl}>
                  <Icon
                    name={isFloorControlOpen ? 'arrow-right' : 'arrow-left'}
                  />
                </FloorControlArrow>
                {!isFloorControlOpen && (
                  <FloorControlLabel>{currentFloor.name}</FloorControlLabel>
                )}
              </FloorControls>
              {isFloorControlOpen && (
                <FloorControlSelect>
                  {floors.map(floor => (
                    <FloorControlOption
                      key={floor.id}
                      selected={floor.id === currentFloor.id}
                      onClick={() => this.setFloor(floor.id)}
                    >
                      <FloorShortName>{floor.shortName}</FloorShortName>
                      {floor.name}
                    </FloorControlOption>
                  ))}
                </FloorControlSelect>
              )}
            </FloorControlsWrapper>

            <ViewControlWrapper>
              <SurveyButtonContainer>
                {isSurveyAvailable && (
                  <SurveyButton onClick={() => this.handleSurvey()}>
                    <SurveyButtonText>Answer our quick survey</SurveyButtonText>
                  </SurveyButton>
                )}
                <div>
                  <CompassWrapper>
                    <CompassContainer rotation={rotation}>
                      <Compass />
                    </CompassContainer>
                    <CompassLabel onClick={this.resetRotation}>N</CompassLabel>
                  </CompassWrapper>

                  <ZoomControlWrapper>
                    <ZoomControlItem onClick={this.zoomIn}>
                      <Icon name="plus" />
                    </ZoomControlItem>
                    <ZoomControlItem onClick={this.zoomOut}>
                      <Icon name="minus" />
                    </ZoomControlItem>
                    <ZoomControlItem onClick={this.showEntireMap}>
                      <Icon name="full-view" />
                    </ZoomControlItem>
                  </ZoomControlWrapper>
                </div>
              </SurveyButtonContainer>
            </ViewControlWrapper>
          </>
        )}
      </MapViewWrapper>
    )
  }
}

IndoorMap.defaultProps = {
  preview: false,
  targetLocation: '',
  nextTargetLocation: null,
  selectedCategory: null,
  searchMode: null,
  handleSearchModeChange: () => {},
  handleChangeMall: () => {},
  handleShowDirection: () => {},
  handleShowLocation: () => {},
  changeDescription: () => {},
  handleBack: null,
}

IndoorMap.propTypes = {
  mall: PropTypes.string.isRequired,
  preview: PropTypes.bool,
  targetLocation: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  nextTargetLocation: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedCategory: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  searchMode: PropTypes.oneOf([
    'search',
    'amenities',
    'categories',
    'directions',
  ]),
  handleSearchModeChange: PropTypes.func,
  handleChangeMall: PropTypes.func,
  handleShowDirection: PropTypes.func,
  handleShowLocation: PropTypes.func,
  changeDescription: PropTypes.func,
  handleBack: PropTypes.func,
  displayProfileModal: PropTypes.func,
  setProfileModalPage: PropTypes.func,
}

export default withMappedinKeys(IndoorMap)
